module.exports = __webpack_public_path__ + "img/instagram.2277f5f9.svg";